import React from "react";
import styled, { css } from "styled-components";
import {
  Button,
  IconLocationTarget,
  useSiteContext
} from "@americanbible/uikit";

import AudioController from "../ChapterAudio/AudioController";
import { isMobileDevice } from "../../../utils/mobile";
import { CHAPTER_MODES } from "./ChapterMode";
import { ViewSettingsMenu } from "../../UI/ViewSettingsMenu";

// ignore pointer events on the element, but enable for children
const pointerEventStyles = css`
  pointer-events: none;

  & * {
    pointer-events: all;
  }
`;

const StyledFooter = styled.div`
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: 1;
  ${pointerEventStyles}
`;

const SettingContainer = styled.div`
  padding: 16px;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: ${props =>
    props.anchor === "right" || isMobileDevice() ? "row-reverse" : "row"};
  justify-content: space-between;
  align-items: flex-end;
  ${pointerEventStyles}
`;

export const ChapterFooter = ({
  audioIsPlayable,
  mode,
  setModeDefault,
  setModeAudioSync
}) => {
  const { scriptDirection } = useSiteContext();
  const anchor = scriptDirection === "rtl" ? "right" : "left";
  const isMobile = isMobileDevice();
  const isAudioUserScrollingMode = mode === CHAPTER_MODES.AUDIO_USER_SCROLLING;
  const showSettings = !isMobile || isAudioUserScrollingMode;

  return (
    <StyledFooter>
      {showSettings && (
        <SettingContainer anchor={anchor}>
          {!isMobile && <ViewSettingsMenu anchor={anchor} />}
          {isAudioUserScrollingMode && (
            <div onClick={setModeAudioSync}>
              <Button
                renderIcon={iconProps => <IconLocationTarget {...iconProps} />}
                type="circle"
              />
            </div>
          )}
        </SettingContainer>
      )}
      {audioIsPlayable && (
        <AudioController
          setModeDefault={setModeDefault}
          setModeAudioSync={setModeAudioSync}
        />
      )}
    </StyledFooter>
  );
};
